import React from 'react';

import Link from '@mui/material/Link';

import { dashboardBaseUrl } from 'api';

interface Props {
  readonly path: string;
  readonly children: React.ReactNode;
}

const ExternalDashboardLink: React.FC<Props> = ({ path, children }) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const href = `${dashboardBaseUrl}${normalizedPath}`;
  return (
    <Link href={href} rel="noopener noreferrer" target="_blank" underline="hover">
      {children}
    </Link>
  );
};

export default ExternalDashboardLink;
